import { render, staticRenderFns } from "./PersonalInformationCN.vue?vue&type=template&id=329fb653"
import script from "./PersonalInformationCN.vue?vue&type=script&lang=js"
export * from "./PersonalInformationCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports